import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-bottomsheetbar',
  templateUrl: './bottomsheetbar.component.html',
  styleUrls: ['./bottomsheetbar.component.scss']
})
export class BottomsheetbarComponent implements OnInit {
  isClosing = false;

  constructor(private router: Router) {}

  ngOnInit() {
    document.body.classList.add('modal-open');
  }

  ngOnDestroy() {
    document.body.classList.remove('modal-open');
  }

  closeSheet() {
    this.isClosing = true;
    setTimeout(() => {
      this.router.navigate(['/transaction/lumpsum']); 
    }, 500); 
  }

}
